var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvgVendemos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "121px",
    height: "93px",
    viewBox: "0 0 121 93",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "retomas") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3B-Liner_Goodparts_Home_Escuro",
    transform: "translate(-1517.000000, -3234.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-81",
    transform: "translate(161.000000, 3069.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Intermedia\\xE7\\xE3o-Copy-8",
    transform: "translate(1218.666667, 117.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "serv_retomas",
    transform: "translate(135.333333, 34.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(63.686016, 61.267422) rotate(45.000000) translate(-63.686016, -61.267422) translate(41.554976, 39.108535)",
    strokeWidth: 4.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.26246992,11.6895943 C-0.358069597,14.3101338 -0.361160552,16.3538213 0.548534043,18.2988711 L0.703783898,18.6134955 L0.703783898,18.6134955 L0.873420457,18.9268438 L0.873420457,18.9268438 L1.05582834,19.2393693 L1.05582834,19.2393693 L1.24939217,19.551525 L1.24939217,19.551525 L7.10065248,28.5543875 L28.576739,7.07830099 L19.886143,1.43011777 L19.5696205,1.2312967 L19.5696205,1.2312967 L19.2537315,1.04146614 C19.2011091,1.01066851 19.1484928,0.980314159 19.0958726,0.950437447 L18.7800221,0.777183517 C18.7273454,0.749354709 18.6746444,0.722072221 18.621909,0.695370395 L18.305003,0.542402128 C16.3472054,-0.354544688 14.3145984,-0.362534176 11.6940589,2.25800534 L2.26246992,11.6895943 Z",
    id: "Vector",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.09973202,
    y1: 24.5892955,
    x2: 1.75747661,
    y2: 25.9315509,
    id: "Vector"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.918074,
    y1: 1.77095355,
    x2: 24.5758186,
    y2: 3.11320896,
    id: "Vector"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.0779241,
    y1: 31.1984659,
    x2: 19.1046903,
    y2: 27.1716997,
    id: "Vector"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.1582228,
    y1: 19.1181672,
    x2: 31.184989,
    y2: 15.091401,
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.109493,21.7542595 L40.5860463,24.2777062 C39.4585517,25.4052007 38.7140875,25.4000093 37.9627653,25.1185118 L37.7475783,25.0313051 L37.7475783,25.0313051 L37.4196777,24.8820102 C37.3826924,24.8646519 37.3454811,24.8471294 37.3080016,24.8295352 L36.2430193,24.3014879 L35.8321051,24.1050347 L35.8321051,24.1050347 L35.5688113,23.9866005 C34.4422557,23.5015557 33.4815134,23.4162266 31.8604152,25.0373248 L24.9880749,31.9096651 C23.4293266,33.4684134 23.4825343,34.4974866 23.9031153,35.5357288 L24.0104711,35.7853589 L24.0104711,35.7853589 L24.1895921,36.1640851 L24.1895921,36.1640851 L24.9441642,37.6878239 L24.9441642,37.6878239 L25.0418891,37.9030251 L25.0418891,37.9030251 L25.1253647,38.1165907 C25.37508,38.828139 25.3154901,39.5482623 24.228429,40.6353235 L21.704982,43.1587704 C20.0942756,44.7694769 17.4782299,44.6947287 16.0815025,42.9758601 L8.63570637,34.0026437 L8.63570637,34.0026437 L8.32312195,33.6097511 L8.32312195,33.6097511 L8.02973863,33.2180614 L8.02973863,33.2180614 L7.84752277,32.9565062 L7.84752277,32.9565062 L7.67789932,32.6938401 C7.59650627,32.5621197 7.52044417,32.4297358 7.4506262,32.2963182 L7.31958633,32.0279953 C6.62727142,30.4984453 6.81517561,28.8044253 9.21262277,26.4069782 L26.339814,9.2797869 C29.0193138,6.60028713 30.820138,6.68080479 32.4947206,7.66548134 L32.7581889,7.82819979 L32.7581889,7.82819979 L33.0202173,8.00432239 L33.0202173,8.00432239 L33.2814639,8.19222568 L33.2814639,8.19222568 L33.6733077,8.49261815 L33.6733077,8.49261815 L34.0670948,8.81038537 L34.0670948,8.81038537 L42.92661,16.1307526 C44.6275819,17.5453767 44.7201995,20.143553 43.109493,21.7542595 Z",
    id: "Vector",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.5841827,79.9031855 L22.5841827,101.403185 M103.811183,60.8111832 C103.811183,84.5471831 84.5471831,103.811183 60.8111832,103.811183 C44.9871832,103.811183 32.2448498,95.8418506 22.5841827,79.9031855 L42.0201837,79.9031855 M17.8111832,60.8111832 C17.8111832,37.0751833 36.9031834,17.8111832 60.8111832,17.8111832 C79.9318501,17.8111832 94.2651834,25.7805164 103.811183,41.7191829 M103.811183,41.7191829 L103.811183,20.2191829 M103.811183,41.7191829 L84.7191809,41.7191829",
    id: "Vector",
    strokeWidth: 5.7,
    fillRule: "nonzero",
    transform: "translate(60.811183, 60.811183) rotate(-315.000000) translate(-60.811183, -60.811183) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgVendemos);
export default __webpack_public_path__ + "static/media/svg_vendemos.322b3d99b18922243e7885a89e9c2a32.svg";
export { ForwardRef as ReactComponent };